import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Header from "src/components/wizard/Header";
import Footer from "src/components/wizard/Footer/Footer";
import IntegrationCounterpartField from "./IntegrationCounterpartField";

export default function IntegrationCounterpartStep({
  title,
  info,
  project,
  linkableType,
  linkableId,
  date,
  onBack,
  onContinue,
  step,
  steps,
  startTime,
  completeTime,
  requireSelection = true,
}) {
  const [linkState, setLinkState] = useState({
    loading: true,
    hasLink: false,
    view: "list",
    lookupByChoice: false,
    waiting: false,
    emptyList: false,
    selected: null,
    confirmDisabled: true,
    confirming: false,
    removing: false,
    openJobSearch: null,
    backToList: null,
    backFromConfirm: null,
    change: null,
    confirmJob: null,
    removeJob: null,
  });
  const [attempted, setAttempted] = useState(false);
  const {
    loading,
    hasLink,
    view,
    waiting,
    emptyList,
    selected,
    confirmDisabled,
    confirming,
    removing,
    openJobSearch,
    backToList,
    backFromConfirm,
    change,
    confirmJob,
    removeJob,
  } = linkState;

  const handleContinue = () => {
    if (requireSelection && !hasLink) {
      setAttempted(true);
      return;
    }
    onContinue();
  };

  const handleBack = () => {
    if (view === "lookup" && backToList) {
      backToList();
      return;
    }
    if (view === "confirm" && backFromConfirm) {
      backFromConfirm();
      return;
    }
    onBack();
  };

  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between" minHeight="100%">
      <Header title={title} info={info} />
      <Box px={2} py={2} flexGrow={1} minHeight={320}>
        <IntegrationCounterpartField
          project={project}
          linkableType={linkableType}
          linkableId={linkableId}
          date={date}
          embedded
          onLinkStateChange={setLinkState}
          error={attempted && requireSelection && !hasLink ? "Required" : undefined}
        />
      </Box>
      <Box mt={2}>
        <Footer step={step} steps={steps} startTime={startTime} completeTime={completeTime}>
          <Box display="flex" gap={1}>
            <Button onClick={handleBack} variant="outlined">
              Back
            </Button>
            {view === "list" && (
              <Button
                variant={emptyList ? "contained" : "outlined"}
                onClick={() => openJobSearch?.()}
                disabled={waiting}
                sx={{ textTransform: "none" }}
              >
                Search By Job ID
              </Button>
            )}
            {view === "confirm" && (
              <Button
                variant="contained"
                disabled={confirmDisabled || confirming}
                onClick={() => confirmJob?.(selected)}
                sx={{ textTransform: "none" }}
              >
                Use This Job
              </Button>
            )}
            {view === "current" && (
              <Button variant="contained" onClick={handleContinue} disabled={loading}>
                Next
              </Button>
            )}
          </Box>
        </Footer>
      </Box>
    </Box>
  );
}
